import DOMPurify from 'dompurify';

// Sanitize HTML for safe insertion into the DOM
export const sanitizeHtml = (html) => {
  try {
    return DOMPurify.sanitize(html || '', {
      USE_PROFILES: { html: true },
      // Conserver les data-* attributes (nécessaires pour les blocs de code et tableaux TipTap)
      ALLOW_DATA_ATTR: true,
    });
  } catch (e) {
    return '';
  }
};

// Strip HTML tags safely and return plain text
export const stripHtml = (html) => {
  const div = document.createElement('div');
  div.innerHTML = sanitizeHtml(html || '');
  return div.textContent || div.innerText || '';
};

export default sanitizeHtml;
